import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "enrollment",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-enrollment" */ "Admissions/features/Enrollment/components/EnrollmentManagement"
    ).then(m => m.default)
  ),
});
